const NotFoundPage = () => <div>Page Not Found</div>;

export default NotFoundPage;
